import { useRef, useState, type ReactNode } from 'react'
import { Button } from '~/components/ui/button'

const ITEMS_PER_PAGE = 3;

function CustomCarousel({ items }: { items: ReactNode[] }) {
  const [current, setCurrent] = useState(1)
  const scrollRef = useRef<HTMLDivElement>(null);
  const pageCount = Math.ceil(items.length / ITEMS_PER_PAGE);
  const showPagination = pageCount > 1;

  const scroll = (dir: "left" | "right") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -400 : 400,
        behavior: "smooth",
      });
    }
  };

  if (!items.length) return null;

  return (
    <div className="relative mt-6">
      <div
        ref={scrollRef}
        className="flex overflow-x-auto space-x-3 scroll-smooth scrollbar-hide"
      >
        {items}
      </div>
      {showPagination && (
        <div className="flex justify-center mt-4">
          <div className="hidden md:flex">
            {Array.from({ length: pageCount }).map((_, id) => (
              <Button
                key={id}
                size="icon"
                variant="ghost"
                className="bg-gray-200 mr-3 h-3 w-3 rounded-full"
                style={{ background: id + 1 === current ? '#aaa ' : '#e5e7eb' }}
                aria-label={`Go to page ${id + 1}`}
                onClick={() => {
                  setCurrent(id + 1)
                  scroll(id + 1 < current ? "left" : 'right')
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomCarousel
